export default __webpack_public_path__ + "static/icon-easy-62e14c8fb002849d02a459eb01df678b.svg";